import React, { useEffect, useState, useRef, useMemo, useContext } from "react";
import axios from "axios";
import Select from "react-select";
import { Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { AppContext } from "../../../context/AppContext";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { Box } from "@mui/material";
import CommonTabular from "../../../components/Datatable/CommonTabular";
import Reportcurrencysymbols from "../../../common/Reportcurrencysymbols";

const PaymentDetailReport = (props) => {
  const token = localStorage.getItem("Token");
  const {
    CurrencySymbol,
    FractionDigits,
    dateFormate,
    ReportViewPermission,
    currencySymbolLocation,
  } = useContext(AppContext);
  const locationid = localStorage.getItem("Location");
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [saletype, setSaletype] = useState([]);
  const [customerId, setcustomerId] = useState([]);
  const [customersdata, setCustomersData] = useState([]);
  const [selectedSaleTypeId, setSelectedSaleTypeId] = useState(0);
  const [classicView, setClassicView] = useState(true);
  const [nemultiselect, setnemultiselect] = useState({
    Location: [],
    PaymentType: [],
    SaleType: [],
  });
  const [totalData, setTotalData] = useState({
    PaymentAmountsum: 0,
    InvoicedAmountSum: 0,
  });

  let dashStyle = {
    // width: "280px",
    background: "#fff",
    marginTop: "10px",
    borderRadius: "6px",
    padding: "20px",
    border: "1px solid #E8EBED",
    // width: "50%",
  };

  const handleDropdownChange = (event) => {
    console.log(event, "event123");
    setSelectReport(event?.value);
    if (event?.value === 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const handleChangeSalesType = (event) => {
    setSelectedSaleTypeId(event?.value);
  };

  let salesTypeDropdownOption = [];
  const SalesTypeDropdown = saletype
    .filter((u) => u.ID !== 3) // Exclude items with ID = 3 Estimate
    .map((u, i) => {
      salesTypeDropdownOption[i] = { label: u.SalesType, value: u.ID };
    });

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedDate(res.data.ResponseData);
        setLoading(false);
        return res;
      });

    axios
      .get(`${config.salesconfigBaseUrl}/sales/saletype`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        setSaletype(response.data.ResponseData);
        console.log(response.data.ResponseData, "===> setSaletype");
      })
      .catch((error) => {
        console.log(error);
      });
    // customer dropdown
    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        const customers = res.data.ResponseData?.map((el) => {
          return { label: el.CompanyName, value: el.Id };
        });
        setCustomersData(customers);
        return res;
      });
  }, []);

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const callback = (payload, enddate2) => {
    setStartDate(payload);
    setEndDate(enddate2);
  };

  // const columns = useMemo(() => [
  //   {
  //     header: "Sale Id",
  //     accessorKey: "InvoiceNumber",
  //     filterFn: "contains",
  //   },
  //   {
  //     header: "Location",
  //     accessorKey: "Location",
  //   },
  //   {
  //     header: "Customer Name",
  //     accessorKey: "CustomerName",
  //     filterFn: "contains",
  //   },
  //   // {
  //   //   header: "Invoice Number",
  //   //   accessorKey: "InvoiceNumber",
  //   //   filterFn: "contains",
  //   // },
  //   {
  //     header: "Sale Date",
  //     accessorKey: "SaleDate",
  //     filterFn: "contains",
  //     Cell: ({ row }) => {
  //       const SaleDate = moment(row.original.SaleDate);
  //       if (SaleDate.isValid()) {
  //         return moment(SaleDate).format(`${dateFormate.toUpperCase()}`);
  //       } else {
  //         return "";
  //       }
  //     },
  //   },
  //   {
  //     header: "Payment Date",
  //     accessorKey: "PaymentDate",
  //     filterFn: "contains",
  //     Cell: ({ row }) =>
  //       moment(row.original.PaymentDate).format("YYYY-MM-DD") === "Invalid date"
  //         ? ""
  //         : moment(row.original.PaymentDate).format(
  //             `${dateFormate.toUpperCase()}`
  //           ),
  //   },
  //   {
  //     header: "Payment Type",
  //     accessorKey: "PaymentType",
  //     filterSelectOptions: nemultiselect?.PaymentType, // ["paid", "unpaid"],
  //     filterVariant: "multi-select", //"select",
  //     enableColumnFilterModes: false,
  //   },
  //   // {
  //   //   header: "Total Amount",
  //   //   accessorKey: "TotalAmount",
  //   //   filterFn: "contains",
  //   //   Cell: ({ row }) => {
  //   //     const TotalAmount = row?.original?.TotalAmount;
  //   //     if (TotalAmount == "0.00" || TotalAmount == "") {
  //   //       return "";
  //   //     } else {
  //   //       return (
  //   //         <div>
  //   //           {CurrencySymbols(
  //   //             Number(TotalAmount),
  //   //             { CurrencySymbol },
  //   //             FractionDigits
  //   //           )}
  //   //         </div>
  //   //       );
  //   //     }
  //   //   },
  //   // },
  //   {
  //     header: "Payment Amount",
  //     accessorKey: "PaymentAmount",
  //     filterFn: "contains",
  //     Cell: ({ row }) => (
  //       <Box
  //         component="span"
  //         sx={{
  //           borderRadius: "0.3rem",
  //           color: "#343f62",
  //           maxWidth: "18ch",
  //           fontWeight: "700",
  //           textDecoration: "underline",
  //           textUnderlineOffset: "3px",
  //           p: "0.3rem",
  //           cursor: "pointer",
  //           display: "flex",
  //           alignItems: "center",
  //         }}
  //         onClick={() =>
  //           window.open(`/receive-payment/${row.original.SaleTxnId}`)
  //         }
  //       >
  //         {CurrencySymbols(
  //           Number(row.original.PaymentAmount),
  //           { CurrencySymbol },
  //           FractionDigits
  //         )}
  //       </Box>
  //     ),
  //     AggregatedCell: ({ cell, row }) => {
  //       const aggregatedValue = cell.getValue();
  //       const isItemName = row.depth === 0; // Adjust based on your table's grouping structure

  //       const formattedValue =
  //         typeof aggregatedValue === "number" && isItemName
  //           ? CurrencySymbols(
  //               Number(aggregatedValue),
  //               { CurrencySymbol },
  //               FractionDigits
  //             )
  //           : "";

  //       return isItemName ? (
  //         <>
  //           <Box component="span" sx={{ fontWeight: "bold" }}>
  //             Total :
  //           </Box>{" "}
  //           <Box
  //             sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
  //           >
  //             {formattedValue}
  //           </Box>
  //         </>
  //       ) : null;
  //     },
  //   },
  //   // {
  //   //   header: "Account Number",
  //   //   accessorKey: "AccountNumber",
  //   //   filterFn: "contains",
  //   // },
  //   {
  //     header: "Sale Type",
  //     accessorKey: "SaleType",
  //     Cell: ({ row }) => (
  //       <Box
  //         component="span"
  //         sx={{
  //           borderRadius: "0.3rem",
  //           color: "#343f62",
  //           maxWidth: "18ch",
  //           fontWeight: "700",
  //           textDecoration: "underline",
  //           textUnderlineOffset: "3px",
  //           p: "0.3rem",
  //           cursor: "pointer",
  //           display: "flex",
  //           alignItems: "center",
  //         }}
  //         onClick={() =>
  //           window.open(`/sales-receipt/${row.original.InvoiceNumber}`)
  //         }
  //       >
  //         {row.original.SaleType}
  //       </Box>
  //     ),
  //   },
  //   {
  //     header: "Account Name",
  //     accessorKey: "AccountName",
  //     filterFn: "contains",
  //   },
  // ]);

  const columns = useMemo(() => [
    // {
    //   header: "ID",
    //   accessorKey: "ID",
    //   filterFn: "contains",
    //   size: "100",
    // },
    {
      header: "Customer Name",
      accessorKey: "CustomerName",
      filterFn: "contains",
      size: "120",
    },
    {
      header: "Date",
      filterFn: "contains",
      accessorFn: (originalRow) => moment(originalRow.Date),
      filterVariant: "date",
      size: "90",
      Cell: ({ row }) =>
        moment(row.original.Date).format(`${dateFormate.toUpperCase()}`),
    },
    {
      header: "Transaction Type",
      accessorKey: "TransactionType",
      filterFn: "contains",
      size: "120",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            // fontWeight: "700",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
          }}
          onClick={() => {
            // const isPayment = row.original?.TransactionType === "Payment";
            const url =
              row.original?.TransactionType === "Payment"
                ? `/receive-payment/${row.original.SaleId}`
                : row.original?.TransactionType === "Sale" ||
                  row.original?.TransactionType === "Return/ Memo"
                ? `/sales-receipt/${row.original.SaleId}`
                : row.original?.TransactionType === "Journal Entry"
                ? `/journal-entry/${row.original.SaleId}`
                : row.original?.TransactionType === "Deposit"
                ? `/bank-deposit/${row.original.SaleId}`
                : `/Expense/${row.original.SaleId}`;

            window.open(url, "_blank"); // Open in a new tab
          }}
        >
          {row.original.TransactionType}
        </Box>
      ),
    },
    {
      filterFn: "contains",
      header: "Memo / Description",
      accessorKey: "MemoDescription",
      filterFn: "contains",
      size: "140",
    },
    {
      header: "Num",
      accessorKey: "Num",
      filterFn: "contains",
      size: "100",
    },
    {
      header: "Amount",
      accessorKey: "Amount",
      filterFn: "contains",
      size: "100",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
          }}
          onClick={() => {
            const url =
              row.original?.TransactionType === "Payment"
                ? `/receive-payment/${row.original.SaleId}`
                : row.original?.TransactionType === "Sale" ||
                  row.original?.TransactionType === "Return/ Memo"
                ? `/sales-receipt/${row.original.SaleId}`
                : row.original?.TransactionType === "Journal Entry"
                ? `/journal-entry/${row.original.SaleId}`
                : row.original?.TransactionType === "Deposit"
                ? `/bank-deposit/${row.original.SaleId}`
                : `/Expense/${row.original.SaleId}`;

            window.open(url, "_blank"); // Open in a new tab
          }}
        >
          {CurrencySymbols(
            Number(row.original.Amount),
            { CurrencySymbol },
            FractionDigits
          )}
        </Box>
      ),
    },
    {
      header: "Open Balance",
      accessorKey: "OpenBalance",
      filterFn: "contains",
      size: "100",
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            <p>
              {CurrencySymbols(
                Number(row.original.OpenBalance),
                { CurrencySymbol },
                FractionDigits
              )}
            </p>
          </div>
        );
      },
    },
    {
      header: "Created Date",
      accessorKey: "CreatedDate",
      filterFn: "contains",
      accessorFn: (originalRow) => moment(originalRow.CreatedDate),
      size: "140",
      Cell: ({ row }) => {
        const CreatedDate = row?.original?.CreatedDate;
        if (
          CreatedDate === "0000-00-00" ||
          CreatedDate === "" ||
          CreatedDate === null
        ) {
          return "";
        }
        return moment(CreatedDate).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        );
      },
    },
    {
      header: "Created By",
      accessorKey: "CreatedBy",
      filterFn: "contains",
      size: "100",
    },
    {
      header: "Split",
      accessorKey: "Split",
      filterFn: "contains",
      size: "100",
    },
    {
      header: "Due Date",
      accessorKey: "DueDate",
      size: "150",
      // accessorFn: (originalRow) => moment(originalRow.DueDate),
      Cell: ({ row }) =>
        moment(row.original.DueDate).format(`${dateFormate.toUpperCase()}`),
    },
    {
      header: "Vendor Message",
      accessorKey: "VendorMessage",
      filterFn: "contains",
      size: "120",
    },
    {
      header: "Terms",
      accessorKey: "Terms",
      filterFn: "contains",
      size: "110",
    },

    {
      header: "Account",
      accessorKey: "Account",
      filterFn: "contains",
      size: "130",
    },
    {
      header: "Payment Method",
      accessorKey: "PaymentMethod",
      filterFn: "contains",
      size: "100",
    },
    {
      header: "AR Paid",
      accessorKey: "ARPaid",
      filterFn: "contains",
      size: "100",
    },
    // {
    //   header: "Delivery Address",
    //   accessorKey: "DeliveryAddress",
    //   filterFn: "contains",
    //   size: "110",
    // },
    // {
    //   header: "CustomerID",
    //   accessorKey: "CustomerID",
    // },
    // {
    //   header : "Total Record" ,
    //   accessorKey : "TotalRecord",
    // },
    {
      header: "Last Modified",
      accessorKey: "ModifiedDate",
      Cell: ({ row }) => {
        const ModifiedDate = row?.original?.ModifiedDate;
        if (
          ModifiedDate === "0000-00-00" ||
          ModifiedDate === "" ||
          ModifiedDate === null
        ) {
          return "";
        }
        return moment(ModifiedDate).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        );
      },
    },
    {
      header: "Last Modified By",
      accessorKey: "ModifiedBy",
    },
  ]);

  const Classiccolumns = [
    {
      title: "Customer Name",
      field: "CustomerName",
      headerFilter: "input",
      defaultVisible: true,
      frozen: true,
      // formatter: function (cell) {
      //   const data = cell.getData();
      //   const value = cell.getValue();

      //   // Apply red bold style if ParentCustomerID === 0
      //   if (data.ParentCustomerID == 0) {
      //     return `<span style="color: #1a2649; font-weight: bold;">${value}</span>`;
      //   }
      //   if (data.ParentCustomerID > 0) {
      //     return `<span class="tree-child">&nbsp;&nbsp;&nbsp;&nbsp;└── ${value}</span>`;
      //   }

      //   return value;
      // },
    },
    {
      title: "Date",
      field: "Date",
      headerFilter: "input",
      defaultVisible: true,
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()} h:mm A`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
    {
      title: "Transaction Type",
      field: "TransactionType",
      headerFilter: "input",
      defaultVisible: true,
      formatter: (cell) => {
        const data = cell.getRow().getData();
        const span = document.createElement("span");

        span.textContent = data.TransactionType || "";
        span.style.borderRadius = "0.3rem";
        span.style.color = "#343f62";
        span.style.maxWidth = "18ch";
        span.style.textDecoration = "underline";
        span.style.textUnderlineOffset = "3px";
        span.style.padding = "0.3rem";
        span.style.cursor = "pointer";
        span.style.display = "flex";
        span.style.alignItems = "center";
        span.style.overflow = "hidden";
        span.style.whiteSpace = "nowrap";
        span.style.textOverflow = "ellipsis";
        span.style.fontWeight = "900";

        span.addEventListener("click", (e) => {
          e.preventDefault();
          const type = data.TransactionType;
          const saleId = data.SaleId;
          let url = `/Expense/${saleId}`; // default

          if (type === "Payment") {
            url = `/receive-payment/${saleId}`;
          } else if (type === "Sale" || type === "Return/ Memo") {
            url = `/sales-receipt/${saleId}`;
          } else if (type === "Journal Entry") {
            url = `/journal-entry/${saleId}`;
          } else if (type === "Deposit") {
            url = `/bank-deposit/${saleId}`;
          }

          window.open(url, "_blank");
        });

        return span;
      },
    },

    {
      title: "Memo / Description",
      field: "MemoDescription",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Num",
      field: "Num",
      headerFilter: "input",
      defaultVisible: true,
    },
    // {
    //   title: "Amount",
    //   field: "Amount",
    //   headerMenu: headerMenu,
    //   headerFilter: "input",
    //   defaultVisible: true,
    //   bottomCalc: "sum",
    //   topCalcFormatter: function (cell) {
    //     const totalValue = cell.getValue();
    //     if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
    //       return `${CurrencySymbol}0.0`;
    //     }

    //     return Reportcurrencysymbols(
    //       Number(totalValue),
    //       { CurrencySymbol },
    //       FractionDigits,
    //       currencySymbolLocation
    //     );
    //   },
    //   bottomCalcFormatter: function (cell) {
    //     const totalValue = cell.getValue();
    //     if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
    //       return `${CurrencySymbol}0.0`;
    //     }

    //     return Reportcurrencysymbols(
    //       Number(totalValue),
    //       { CurrencySymbol },
    //       FractionDigits,
    //       currencySymbolLocation
    //     );
    //   },
    //   formatter: function (cell) {
    //     const value = cell.getValue();
    //     if (value == "0.00" || value === "") {
    //       return `${CurrencySymbol}0.0`;
    //     }
    //     return Reportcurrencysymbols(
    //       Number(value),
    //       { CurrencySymbol },
    //       FractionDigits,
    //       currencySymbolLocation
    //     );
    //   },
    // },
    {
      title: "Amount",
      field: "Amount",
      headerFilter: "input",
      // width: "120px",
      defaultVisible: true,
      bottomCalc: "sum",
      // topCalc: "sum",

      // Top Total Formatter
      // topCalcFormatter: function(cell) {
      //   const totalValue = cell.getValue();
      //   const formattedValue = (!totalValue || totalValue == "0.00")
      //     ? `${CurrencySymbol}0.0`
      //     : Reportcurrencysymbols(
      //         Number(totalValue),
      //         { CurrencySymbol },
      //         FractionDigits,
      //         currencySymbolLocation
      //       );
      //   return `<span style="font-weight:bold;">${formattedValue}</span>`;
      // },

      // Bottom Total Formatter
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        const formattedValue =
          !totalValue || totalValue == "0.00"
            ? `${CurrencySymbol}0.0`
            : Reportcurrencysymbols(
                Number(totalValue),
                { CurrencySymbol },
                FractionDigits,
                currencySymbolLocation
              );
        return `<span style="font-weight:bold;">${formattedValue}</span>`;
      },

      // Cell Formatter with Navigation
      formatter: function (cell, formatterParams, onRendered) {
        const value = cell.getValue();
        const rowData = cell.getRow().getData();

        // Create wrapper element
        const element = document.createElement("span");
        element.style.cssText = `
      display: inline-block;
      border-radius: 0.3rem;
      color: #343f62;
      max-width: 18ch;
      text-decoration: underline;
      text-underline-offset: 3px;
      padding: 0.3rem;
      cursor: pointer;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `;

        // Format the value
        const formattedValue =
          !value || value == "0.00"
            ? `${CurrencySymbol}0.0`
            : Reportcurrencysymbols(
                Number(value),
                { CurrencySymbol },
                FractionDigits,
                currencySymbolLocation
              );

        element.innerHTML = formattedValue;

        // Add click handler
        element.addEventListener("click", (e) => {
          e.stopPropagation();
          if (!rowData?.SaleId) return;

          let url = "";
          switch (rowData.TransactionType) {
            case "Payment":
              url = `/receive-payment/${rowData.SaleId}`;
              break;
            case "Sale":
            case "Return/ Memo":
              url = `/sales-receipt/${rowData.SaleId}`;
              break;
            case "Journal Entry":
              url = `/journal-entry/${rowData.SaleId}`;
              break;
            case "Deposit":
              url = `/bank-deposit/${rowData.SaleId}`;
              break;
            default:
              url = `/Expense/${rowData.SaleId}`;
          }

          window.open(url, "_blank");
        });

        return element;
      },

      // Optional: Cell click handler (alternative approach)
      // cellClick: function(e, cell) {
      // This is handled in the formatter, but kept for compatibility
      // e.stopPropagation();
      // }
    },
    {
      title: "Open Balance",
      field: "OpenBalance",
      headerFilter: "input",
      // defaultVisible: true,
      bottomCalc: "sum",
      // topCalcFormatter: function (cell) {
      //   const totalValue = cell.getValue();
      //   if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
      //     return `${CurrencySymbol}0.0`;
      //   }

      //   return Reportcurrencysymbols(
      //     Number(totalValue),
      //     { CurrencySymbol },
      //     FractionDigits,
      //     currencySymbolLocation
      //   );
      // },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },

    {
      title: "Created Date",
      field: "CreatedDate",
      headerFilter: "input",
      // defaultVisible: true,
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()} h:mm A`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
    {
      title: "Created By",
      field: "CreatedBy",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Split",
      field: "Split",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Due Date",
      field: "DueDate",
      headerFilter: "input",
      // defaultVisible: true,
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()} h:mm A`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
    {
      title: "Modified Date",
      field: "ModifiedDate",
      headerFilter: "input",
      // defaultVisible: true,
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()} h:mm A`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
    {
      title: "Modified By",
      field: "ModifiedBy",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Vendor Message",
      field: "VendorMessage",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Terms",
      field: "Terms",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Account",
      field: "Account",
      headerFilter: "input",
      // defaultVisible: true,
    },
    {
      title: "Payment Method",
      field: "PaymentMethod",
      headerFilter: "input",
      defaultVisible: true,
    },

    {
      title: "ARPaid",
      field: "ARPaid",
      headerFilter: "input",
      // defaultVisible: true,
    },
    // {
    //   title: "Billing Address",
    //   field: "BillingAddress",
    //   headerMenu: headerMenu,
    //   headerFilter: "input",
    //   defaultVisible: true,
    // },
    // {
    //   title: "Shipping Address",
    //   field: "DeliveryAddress",
    //   headerMenu: headerMenu,
    //   headerFilter: "input",
    //   defaultVisible: true,
    // },
    // {
    //   title: "Email",
    //   field: "Email",
    //   headerMenu: headerMenu,
    //   headerFilter: "input",
    //   defaultVisible: true,
    // },
    // {
    //   title: "Description",
    //   field: "Description",
    //   headerMenu: headerMenu,
    //   headerFilter: "input",
    //   defaultVisible: true,
    // },
  ];

  const apicall = () => {
    setLoading(true);
    setResponseData([]);
    setTotalData({ PaymentAmountsum: 0, InvoicedAmountSum: 0 });
    axios
      .get(
        `${config.reportsBaseUrl}/reports/paymentdetailreport?filtercolumnsearchtext=&currentorder=&ordercolumn=&pagesize=0&pagenumber=0&filtertext=&startdate=${startdate}&enddate=${enddate}&saleTypeId=${selectedSaleTypeId}&locationid=${locationid}&customerids=${customerId}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          const numArr = res.data.ResponseData.map((obj) => {
            return {
              ...obj,
              PaymentAmount: obj.PaymentAmount ? Number(obj.PaymentAmount) : 0,
            };
          });
          setResponseData(numArr);
          setTotalData({
            ...totalData,
            PaymentAmountsum: numArr.reduce(
              (sum, item) =>
                item.TransactionType === "Payment"
                  ? sum + (parseFloat(item.Amount) || 0)
                  : sum,
              0
            ),
            InvoicedAmountSum: numArr.reduce(
              (sum, item) =>
                item.TransactionType !== "Payment"
                  ? sum + (parseFloat(item.Amount) || 0)
                  : sum,
              0
            ),
          });
        } else {
          setTotalData({
            ...totalData,
            PaymentAmountsum: 0,
            InvoicedAmountSum: 0,
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        return;
      });
  };

  const muiTableBodyCellProps = ({ row }) => {
    return {
      sx: {
        fontWeight: row.original?.ID == 0 ? "bold !important" : "normal",
      },
    };
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Payment Detail Report
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    // defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-3">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}
            {/*<div className="col-sm-2">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Sale Type
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    onChange={(event) => {
                      handleChangeSalesType(event);
                    }}
                    value={salesTypeDropdownOption?.find(
                      (el) => el.value == selectedSaleTypeId
                    )}
                    options={salesTypeDropdownOption}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select mt-1"
                  />
                </div>
              </div>
            </div>*/}
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Customer
              </label>
              <div className="row">
                <div className="col-md-12 z-4">
                  <Select
                    options={customersdata}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    isMulti={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    onChange={(selected) =>
                      setcustomerId(selected?.map((e) => e.value) || [])
                    }
                    value={customersdata.filter((b) =>
                      customerId.includes(b.value)
                    )}
                    className="custom-search-select"
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
          </div>

          {/* Receipt */}

          {responseData.length > 0 && (
            <>
              <div
                className="row"
                style={{
                  display: "grid",
                  gap: "1rem",
                  gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
                }}
              >
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {/* ${totalData.SubTotalSum} */}
                        {CurrencySymbols(
                          Number(totalData.InvoicedAmountSum),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Total Invoiced</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {/* ${totalData.TotalSum} */}
                        {CurrencySymbols(
                          Number(totalData.PaymentAmountsum),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Total Paid</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card mt-3" id="print">
                <div className="card-body">
                  <div className="container">
                    <div className="col-md-12 text-center" id="header">
                      <h6 className="P">Sonar Pos</h6>
                      <p className="fw-bold p-regular">Payment Detail Report</p>
                      <div className="row">
                        <p>
                          Date:{" "}
                          {startdate === "" && enddate === ""
                            ? "All Data"
                            : moment(startdate).format("MM/DD/YYYY") +
                              " - " +
                              moment(enddate).format("MM/DD/YYYY")}
                        </p>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div>
                    {ReportViewPermission == true ? (
                      <button
                        className="btn btn-secondary"
                        onClick={() => setClassicView(!classicView)}
                      >
                        {" "}
                        {classicView ? "Classic View" : "Morden View"}
                      </button>
                    ) : (
                      <></>
                    )}
                    {classicView ? (
                      <CommonTabular
                        Data={responseData}
                        columns={Classiccolumns}
                        Groupvalue={["CustomerName"]}
                        Reportname={"Payment Detail Report"}
                        frozenRowvalue={0}
                        // layout={"fitDataFill"}
                        Onrefresh={() => apicall()}
                      />
                    ) : (
                      <CommonMatrialReactTable
                        MainHeading="Sonar POS"
                        ReportHeading="Payment Detail Report"
                        columns={columns}
                        data={responseData}
                        startdate={startdate}
                        enddate={enddate}
                        columnGrouping={["CustomerName"]}
                        enableExpandAll={true}
                        enableExpanding={true}
                        expanded={true}
                        enableRowSelection={false}
                        muiTableBodyCellProps={muiTableBodyCellProps}
                        columnsVisibility={{
                          CustomerName: false,
                          ID: false,
                          OpenBalance: false,
                          CreatedDate: false,
                          CreatedBy: false,
                          Split: false,
                          DueDate: false,
                          VendorMessage: false,
                          Terms: false,
                          Account: false,
                          ARPaid: false,
                          ModifiedDate: false,
                          ModifiedBy: false,
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default PaymentDetailReport;
